export const MISSING_VALUE_LABEL = "N/A";
